export default class FileInput {
    constructor({
        root = document,
        inputSelector = '.wpcf7-file',
        wrapperSelector = '.form-file',
        valueSelector = '.js-file-value',
        clearSelector = '.js-file-clear',
        defaultText = '',
    } = {}) {
        this.root = root;
        this.inputSelector = inputSelector;
        this.wrapperSelector = wrapperSelector;
        this.valueSelector = valueSelector;
        this.clearSelector = clearSelector;
        this.defaultText = defaultText;

        this.init();
    }

    init() {
        this.inputs = [...this.root.querySelectorAll(this.inputSelector)];

        if (!this.inputs.length) return;

        this.inputs.forEach((input) => {
            if (input.dataset.fileInputInitialized === 'true') return;

            input.removeAttribute('required');

            const formFile = input.closest(this.wrapperSelector);

            if (!formFile) return;

            const clearBtn = formFile.querySelector(this.clearSelector);
            const trigger = formFile.querySelector('.form-file-trigger');

            if (trigger) {
                trigger.addEventListener('click', (event) => {
                    event.preventDefault();
                    input.click();
                });
            }

            input.addEventListener('change', () => {
                this.handleChange(input);
            });

            if (clearBtn) {
                clearBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.clearFile(input);
                });
            }

            input.dataset.fileInputInitialized = 'true';

            this.handleChange(input);
        });

        this.initValidation();
        this.initFormReset();
    }

    initValidation() {
        document.addEventListener('wpcf7invalid', (event) => {
            this.inputs.forEach((input) => {
                if (!event.target.contains(input)) return;

                const files = Array.from(input.files || []);

                if (!files.length) {
                    this.showError(input);
                }
            });
        });
    }

    initFormReset() {
        document.addEventListener('wpcf7mailsent', (event) => {
            this.inputs.forEach((input) => {
                if (!event.target.contains(input)) return;

                this.clearFile(input);
            });
        });
    }

    handleChange(input) {
        const formFile = input.closest(this.wrapperSelector);

        if (!formFile) return;

        const valueEl = formFile.querySelector(this.valueSelector);

        if (!valueEl) return;

        const files = Array.from(input.files || []);

        if (!files.length) {
            valueEl.textContent = this.defaultText;
            formFile.classList.remove('has-file');

            return;
        }

        valueEl.textContent = files.map((file) => file.name).join(', ');

        formFile.classList.add('has-file');

        this.removeError(input);
    }

    showError(input) {
        const formFile = input.closest(this.wrapperSelector);

        if (!formFile) return;

        input.classList.add('wpcf7-not-valid');
        input.setAttribute('aria-invalid', 'true');

        let error = formFile.querySelector('.wpcf7-not-valid-tip');

        if (!error) {
            error = document.createElement('span');
            error.className = 'wpcf7-not-valid-tip';

            formFile.appendChild(error);
        }

        error.textContent = 'Please fill out this field.';
    }

    removeError(input) {
        const formFile = input.closest(this.wrapperSelector);

        if (!formFile) return;

        input.classList.remove('wpcf7-not-valid');
        input.setAttribute('aria-invalid', 'false');

        const error = formFile.querySelector('.wpcf7-not-valid-tip');

        if (error) {
            error.remove();
        }
    }

    clearFile(input) {
        const formFile = input.closest(this.wrapperSelector);

        if (!formFile) return;

        const valueEl = formFile.querySelector(this.valueSelector);

        input.value = '';

        if (valueEl) {
            valueEl.textContent = this.defaultText;
        }

        formFile.classList.remove('has-file');

        this.removeError(input);
    }
}